import { css } from 'emotion';

export const description = css(`
	max-width: 100%;
`);
